import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spinner, Box } from '@chakra-ui/react';

/**
 * This route wrapper protects admin pages.
 * It grants access *ONLY* if the user has 'SuperAdmin: true'
 */
const SuperAdminRoute = ({ children, component: Component, ...rest }) => {
  const { currentUser, SuperAdmin, loading } = useAuth();

  if (loading) {
    return (
      <Box w="100%" h="100vh" display="flex" justifyContent="center" alignItems="center">
        <Spinner size="xl" />
      </Box>
    );
  }

  // `component` must be destructured out and rendered inside `render`: if it
  // were spread onto <Route> alongside `render`, React Router would use it
  // directly and skip the guard entirely (component takes precedence).
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        // Check for SuperAdmin boolean (from state or currentUser)
        (currentUser && (currentUser.SuperAdmin === true || SuperAdmin === true)) ? (
          <Box
            transform="scale(0.9)"
            transformOrigin="top left"
            w="111.11%"
            sx={{
              '& > .chakra-container': {
                maxWidth: '100%',
              },
            }}
          >
            {Component ? <Component {...routeProps} /> : children}
          </Box>
        ) : (
          <Redirect
            to={{
              pathname: '/', // Redirect to dashboard
              state: { from: routeProps.location },
            }}
          />
        )
      }
    />
  );
};

export default SuperAdminRoute;

